import { type ComponentProps, memo } from 'react';

import { ModalSectionHeader } from '~/components/SharePrivateCollectionModal/components/ModalSectionHeader';

export type ModalSectionProps = Pick<ComponentProps<'div'>, 'children'> & {
  label: string;
};

export const ModalSection = memo(({ children, label }: ModalSectionProps) => (
  <div className="flex flex-col gap-2 px-8 pt-4">
    <ModalSectionHeader label={label} />
    {children}
  </div>
));

ModalSection.displayName = 'ModalSection';
